export default function clientsSlider() {

    const clientsSlider = document.querySelector('.js-clientsSlider');

    if (!clientsSlider) {
        return false;
    }

    if (window.innerWidth > 1023) {
        return false;
    }

    $('.js-clientsSlider').not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        dotsClass: 'certificate_dots',
        prevArrow: '<button type="button" class="clients_arrow-prev"></button>',
        nextArrow: '<button type="button" class="clients_arrow-next"></button>',
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                }
            }
        ]
    });

}